/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsSoccerIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-soccer"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.21Q1.2 14.25 1.2 12Q1.2 9.75 2.05 7.79Q2.9 5.83 4.36 4.36Q5.83 2.9 7.79 2.05Q9.75 1.2 12 1.2Q14.25 1.2 16.21 2.05Q18.18 2.9 19.64 4.36Q21.1 5.83 21.95 7.79Q22.8 9.75 22.8 12Q22.8 14.25 21.95 16.21Q21.1 18.18 19.64 19.64Q18.18 21.1 16.21 21.95Q14.25 22.8 12 22.8ZM17.3 9.1L18.45 8.7L18.8 7.55Q18 6.38 16.91 5.53Q15.82 4.67 14.55 4.25L13.35 5.1L13.35 6.3ZM6.7 9.1L10.65 6.3L10.65 5.1L9.45 4.25Q8.18 4.67 7.06 5.53Q5.95 6.38 5.15 7.55L5.5 8.7ZM5.8 17.2L6.7 17.15L7.3 15.9L5.85 11.6L4.65 11.15L3.85 11.8Q3.85 13.38 4.31 14.69Q4.78 16 5.8 17.2ZM12 20.15Q12 20.15 12.32 20.15Q12.65 20.15 13.29 20.07Q13.93 20 14.45 19.8L15.05 18.45L14.55 17.55L9.45 17.55L8.9 18.45L9.55 19.8Q10.13 20 10.74 20.07Q11.35 20.15 12 20.15ZM9.8 14.9L14.15 14.9L15.55 11.1L12 8.65L8.55 11.1ZM18.2 17.2Q19.23 16 19.69 14.69Q20.15 13.38 20.15 11.8L19.3 11.2L18.15 11.6L16.7 15.9L17.3 17.15Z" fill={color} />
    </svg>
  );
}
